import React from 'react';
import styled from 'styled-components';
import Header from './Header';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: linear-gradient(135deg, #0e1633 0%, #1e2a4a 100%);
  color: #fff;
`;

const Main = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

function Layout({ children }) {
  return (
    <PageContainer>
      <Header />
      <Main>{children}</Main>
    </PageContainer>
  );
}

export default Layout; 